import { db, ScreenplayEntity } from '@/shared/lib/db'
import { BaseLocalRepository } from '@/shared/services/repository/BaseRepository'
import { ScreenplayRepository } from './screenplay.repository'

export class ScreenplayLocalRepository extends BaseLocalRepository<ScreenplayEntity> implements ScreenplayRepository {
    constructor() {
        super(db.screenplays, 'screenplays')
    }

    async getAllByProject(projectId: string): Promise<ScreenplayEntity[]> {
        return this.table.where('projectId').equals(projectId).toArray()
    }

    async getByTitle(projectId: string, title: string): Promise<ScreenplayEntity | undefined> {
        const screenplays = await this.getAllByProject(projectId)
        return screenplays.find(s => s.title === title)
    }

    async save(item: ScreenplayEntity): Promise<void> {
        return super.save(item)
    }

    async delete(id: string): Promise<void> {
        return super.delete(id)
    }
}

export const screenplayLocalRepository = new ScreenplayLocalRepository()
